module.exports = __webpack_public_path__ + "static/media/Keen.57ddabcd.jpeg";